import { Component, EventEmitter, Inject, Output, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthApiService, MeApiService } from '@digilize/shared/data/services';
import { ChangePassword, EnvConfig, Me, SnackbarType } from '@digilize/shared/definitions/src';
import { AlertService } from '@digilize/shared/feature/modules/alert';
import { SnackbarService } from '@digilize/shared/feature/modules/snackbar/src';
import { ENV_CONFIG } from '@digilize/shared/utils/tokens/src';
import { ReCaptchaV3Service } from 'ng-recaptcha-2';
import { filter, Subject } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';
import { isFormControlRequired } from '@digilize/shared/utils/helpers/src';
import { passwordStrengthValidator } from '@digilize/shared/utils/validators/src';

@Component({
  selector: 'lib-dialog-change-password',
  templateUrl: './dialog-change-password.component.html',
  styleUrls: ['./dialog-change-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DialogChangePasswordComponent {
  @Output() toSignInClicked = new EventEmitter();
  takeUntil$ = new Subject();

  form = new UntypedFormGroup({
    password: new UntypedFormControl('', [Validators.required]),
    password_new: new UntypedFormControl('', [Validators.required, passwordStrengthValidator()]),
  });
  loading = false;
  resetSuccess;
  me: Me;
  hideCurrentPwd = true;
  hideNewPwd = true;

  constructor(
    public dialogRef: MatDialogRef<DialogChangePasswordComponent>,
    private alertService: AlertService,
    private authApiService: AuthApiService,
    private recaptchaV3Service: ReCaptchaV3Service,
    @Inject(ENV_CONFIG) private envConfig: EnvConfig,
    private snackbarService: SnackbarService,
    private profileApiService: MeApiService
  ) {
    this.authApiService.me.pipe(filter((value) => value != null)).subscribe((me) => {
      this.me = me;
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  isFormControlRequired(formControl): boolean {
    return isFormControlRequired(formControl);
  }

  onSubmit() {
    this.loading = true;
    const changePasswordForm = {
      ...this.form.getRawValue(),
      email: this.me.email,
      password_confirm: this.form.get('password_new').value,
    };

    this.handlePasswordSubmit(changePasswordForm);
  }

  handlePasswordSubmit(changePassword: ChangePassword) {
    this.profileApiService.updatePassword(changePassword).subscribe({
      next: () => {
        this.snackbarService.openSnackbar(SnackbarType.Success, {
          data: { msg: 'alert.custom.password_changed', translate: true },
        });
        // this.authService.softLogout('/auth');
        this.closeDialog();
      },
      error: (err) => {
        if (err?.error?.error?.type === 'forbidden') {
          this.snackbarService.openSnackbar(SnackbarType.Error, {
            data: { msg: 'alert.custom.old_password_incorrect', translate: true },
          });
        }
      },
    });
  }
}
